import * as z from "zod/v4";
import { makeReportDateFilterSchema } from "./base-report-date-filter";
import { ReportFilterType } from "./report-filter-type";

export const ReturnCreatedDateFilterSchema = makeReportDateFilterSchema(
  ReportFilterType.RETURN_CREATED_DATE,
);

export type ReturnCreatedDateFilter = z.infer<
  typeof ReturnCreatedDateFilterSchema
>;
// BaseReportDateFilter<ReportFilterType.RETURN_CREATED_DATE>
